import type {ReactHTML} from 'react'
import {memo} from 'react'

import InjectHtml from '../components/common/InjectHtml/InjectHtml'
import type {OwnProps as InjectHtmlProps} from '../components/common/InjectHtml/InjectHtml.types'
import type {BuildTypeId, ChangeId} from '../types'
import getTransformationPath from '../utils/getTransformationPath'

type AddProps = {
  placeholder: string | null | undefined
  path: string | null | undefined
}
type Props<T extends keyof ReactHTML = 'div'> = Omit<InjectHtmlProps<T>, keyof AddProps> & {
  text: string | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  changeId?: ChangeId | null | undefined
  personal?: boolean
}
export default memo(function TransformText<T extends keyof ReactHTML = 'div'>({
  text,
  buildTypeId,
  changeId,
  personal,
  ...restProps
}: Props<T>) {
  return (
    <InjectHtml
      {...restProps}
      placeholder={text}
      path={getTransformationPath({
        text,
        buildTypeId,
        changeId,
        personal,
      })}
    />
  )
})
